module.exports = __webpack_public_path__ + "static/media/bg2.ebb4bb8c.png";